import { GuestLayout } from '@/layouts/GuestLayout'
import type { GuestProperty } from '@/lib/types'

interface Props {
  property: GuestProperty
}

export default function GuidePending({ property }: Props) {
  return (
    <GuestLayout propertyName={property.name}>
      <div className="flex flex-1 flex-col items-center justify-center gap-3 px-6 text-center">
        <p className="text-base font-medium">{property.name}</p>
        <p className="text-sm text-muted-foreground">
          Your guide is being set up. Check back shortly.
        </p>
      </div>
    </GuestLayout>
  )
}
